import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getGetRunQueryOptions, useGetRunSuspense } from '@/api/generated/endpoints';
import { RouteErrorFallback } from '@/components/route-error-fallback';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { InviteOpsForm } from '@/features/runs/components/invite-ops-form';

export const Route = createFileRoute('/_authenticated/runs/$runId/invite-ops')({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.ensureQueryData(getGetRunQueryOptions(params.runId));
	},
	errorComponent: (props) => <RouteErrorFallback {...props} fallbackMessageKey='error_save_run' />,
	component: InviteOpsRoute,
});

function InviteOpsRoute() {
	const { t } = useTranslation();
	const { runId } = Route.useParams();
	const navigate = useNavigate({ from: '/runs/$runId/invite-ops' });
	const { data: parentRun } = useGetRunSuspense(runId);

	return (
		<Card>
			<CardHeader className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
				<div>
					<CardTitle>{t('runs_invite_ops_title', { customer: parentRun.customer })}</CardTitle>
					<CardDescription>{t('runs_invite_ops_description')}</CardDescription>
				</div>

				<Button asChild variant='outline'>
					<Link to='/runs/$runId' params={{ runId }}>
						<ArrowLeft className='size-4' />
						{t('runs_invite_ops_back_to_run')}
					</Link>
				</Button>
			</CardHeader>

			<CardContent>
				<InviteOpsForm
					parentRun={parentRun}
					onSuccess={(run) => navigate({ to: '/runs/$runId', params: { runId: run.id } })}
				/>
			</CardContent>
		</Card>
	);
}
